export default __webpack_public_path__ + "static/media/invitaciones.dcf1ac80.svg";